import { Fragment, useCallback, useEffect, useState } from "react";
import { CustomCell } from "src/pages/OfferPage/TableSvgOrganizer/CustomCell";
import { RowTools } from "src/pages/OfferPage/TableSvgOrganizer/RowTools/RowTools";
import { formatPriceForcedCurrency } from 'src/utils/formatPrice';
import { hasPermissionForFuncInProject } from 'src/utils/controllerHasPermissionsAdapter';
import { TableCell } from "src/pages/OfferPage/TableSvgOrganizer/TableCell";
import { getAllManufacturersList, setAutoManufacturer } from "src/utils/manufacturerUtil";
import { GetAllManufacturerDiscountForProjectResponse } from "src/model/api/manufacturer-discount.model";
import { ManufacturerRecommendationResponse } from "src/model/api/manufacturer-recommendation";
import { modifyCustomItem, modifyFetchedItem } from "src/utils/CustomRowUtils";
import $ from "jquery"
import {
  useUpdateCableCustomItemMutation,
  useUpdateConventionalDevicesCustomItemMutation,
  useUpdateElectricalCustomItemMutation,
  useUpdateNhcCustomItemMutation,
  useUpdateProjectCustomItemMutation,
  useUpdateRackCabinetCustomItemMutation,
  useUpdateRoomCustomItemMutation
} from "src/api/v1/quote-ApiSlice";
import { useUpdateCustomSectionItemMutation } from "src/api/v1/section-ApiSlice";

export const CustomModifyRow = (
    {
      neededCols,
      cancelCustomRow,
      entityType,
      currency,
      modifyRow,
      setModifyRow,
      modifyMode,
      setModifyMode,
      showTools,
      row,
      dispatchDownloadStates,
      setCurrentRowInEditing,
      projectId,
      measurementSystem,
      allManufacturerDiscountForProject,
      manufacturerRecommendationForProject,
    } : {
      projectId: number;
      neededCols: any;
      cancelCustomRow: () => void;
      entityType: any;
      currency: any;
      modifyRow: boolean;
      setModifyRow: any;
      modifyMode: any;
      setModifyMode: any;
      showTools: boolean;
      row: any;
      dispatchDownloadStates: any;
      setCurrentRowInEditing: any;
      measurementSystem: string;
      allManufacturerDiscountForProject: GetAllManufacturerDiscountForProjectResponse;
      manufacturerRecommendationForProject: ManufacturerRecommendationResponse;
    }
) => {

  const [ updateRoomCustomItem ] = useUpdateRoomCustomItemMutation();
  const [ updateProjectCustomItem ] = useUpdateProjectCustomItemMutation();
  const [ updateElectricalCustomItem ] = useUpdateElectricalCustomItemMutation();
  const [ updateNhcCustomItem ] = useUpdateNhcCustomItemMutation();
  const [ updateCustomSectionItem ] = useUpdateCustomSectionItemMutation();
  const [ updateRackCabinetCustomItem ] = useUpdateRackCabinetCustomItemMutation();
  const [ updateCableCustomItem ] = useUpdateCableCustomItemMutation();
  const [ updateConventionalDevicesCustomItem ] = useUpdateConventionalDevicesCustomItemMutation();

  const [customItem, setCustomItem] = useState({
    ...row,
    net_price: row[`price_${currency}`],
  });
  const [successResponse, setSuccessResponse] = useState(null);
  const [deletedManufacturer, setDeletedManufacturer] = useState<any>(null);


  useEffect(() => {
    //load manufacturer input
    if (
      customItem.internal_product_manufacturer_id !== "" ||
      customItem.user_manufacturer_id !== ""
    ) {
      const manufacturerInput = $("#manufacturer_name");


      const existingManu = getAllManufacturersList(
          manufacturerRecommendationForProject,
          allManufacturerDiscountForProject
      ).find(
        (manu: any) => manu.manufacturer_name == manufacturerInput.val()
      );
      if (existingManu) {
        setAutoManufacturer(manufacturerInput, existingManu);
        setCustomItem({
          ...customItem,
          ...existingManu,
          fetchedManufacturer: true,
        });
      }

    }
  }, []);

  useEffect(() => {
    if (customItem.product_id !== null && !customItem.fetchedItem) {
      setCustomItem({
        ...customItem,
        fetchedItem: true,
      });
    }
  }, [customItem]);

  const confirmCustomRow = useCallback(() => {
    if (customItem && entityType && modifyRow && customItem.fetchedItem) {
      modifyFetchedItem(
        customItem,
        entityType,
        setSuccessResponse,
        modifyMode,
        setModifyMode,
        modifyRow,
        setModifyRow,
        updateRoomCustomItem,
        updateProjectCustomItem,
        updateElectricalCustomItem,
        updateNhcCustomItem,
        updateRackCabinetCustomItem,
        updateCableCustomItem,
        updateConventionalDevicesCustomItem,
        updateCustomSectionItem,
      );
    } else if (customItem && entityType && modifyRow) {
      modifyCustomItem(
        customItem,
        entityType,
        currency,
        setSuccessResponse,
        modifyMode,
        setModifyMode,
        modifyRow,
        setModifyRow,
        updateRoomCustomItem,
        updateProjectCustomItem,
        updateElectricalCustomItem,
        updateNhcCustomItem,
        updateCustomSectionItem,
      );
    }
  }, [customItem, entityType, modifyRow, customItem.fetchedItem]);

  const handleChange = (event: any) => {
    const newCustomItem = Object.assign({}, customItem);
    setCustomItem({
      ...newCustomItem,
      [event.target.id]: event.target.value,
    });
  };

  useEffect(() => {
    if (successResponse) {
      setCurrentRowInEditing({});
    }
  }, [successResponse]);

  useEffect(() => {
    if (deletedManufacturer) {
      const newCustomItem = Object.assign({}, customItem);
      setCustomItem({ ...newCustomItem, ...deletedManufacturer });
      setDeletedManufacturer(null);
    }
  }, [deletedManufacturer]);

  return hasPermissionForFuncInProject(
    "quote_sect.add_custom_product",
    projectId
  ) ? (
    <Fragment>
      {neededCols.map((col: any, key: any) => (
        <TableCell
          key={key}
          width={col.data === "manufacturer_name" || col.data === "custom_description" ? "200" : "width" in col ? col.width : "auto"}
          numeric={col.numeric}
          cellCallback={col.cellCallback}
        >
          {((row.specification_type === "installation" ||
            row.specification_type === "personalisation") &&
            (col.data === "product_name" || col.data === "quantity")) ||
          (entityType === "roomtable" && col.data === `price_${currency}`) ? (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                height: "40px",
                padding: "0 15px",
                textAlign: "left",
              }}
            >
              {col.render(row[col.data], row, {
                measurementSystem: measurementSystem,
              })}
            </div>
          ) : col.data === "net_price" &&
            entityType !== "projectcustomtable" &&
            customItem &&
            customItem.product_id !== null &&
            customItem[`price_${currency}`] ? (
            <div>
              {formatPriceForcedCurrency(
                customItem[`price_${currency}`],
                currency
              )}
            </div>
          ) : (
            <CustomCell
              index={key + 1}
              isNumeric={col.numeric ? col.numeric : false}
              cellName={col.data}
              placeholder={col.title}
              handleChange={handleChange}
              defaultValue={
                col.data === "net_price"
                  ? row[`price_${currency}`]
                  : row[col.data]
              }
              hidden={
                (row.specification_type === "installation" ||
                  row.specification_type === "personalisation") &&
                col.data === "custom_description"
              }
              autoFocus={
                ((row.specification_type === "installation" ||
                  row.specification_type === "personalisation") &&
                  col.data === "net_price") ||
                col.data === "product_name"
              }
              confirmRow={confirmCustomRow}
              cancelRow={cancelCustomRow}
              customItem={customItem}
            />
          )}

          {showTools && col.data === "product_name" ? (
            <RowTools
              cancelCustomRow={cancelCustomRow}
              confirmCustomRow={confirmCustomRow}
              modifyRow={modifyRow}
              setModifyRow={setModifyRow}
              modifyMode={modifyMode}
              setModifyMode={setModifyMode}
              minusRow={true}
            />
          ) : null}
        </TableCell>
      ))}
    </Fragment>
  ) : null;
};
